module.exports = __webpack_public_path__ + "img/Campfire.779b4417.png";